import React, { useState, useEffect, useContext } from 'react';
import FieldDropdown from '../../../../components/FieldDropdown/FieldDropdown';
import { API } from '../../../../API/API';
import { UserContext } from '../../../../context/UserContext';
import FieldDate from '../../../../components/FieldDate/FieldDate';
import FieldText from '../../../../components/FieldText/FieldText';
import { message } from 'antd';
import { MessageConst } from '../../../../const/MessageConst';
import { Row, Col } from 'antd';
import { constData } from '../../../../const/Const';
import FieldTextArea from '../../../../components/FieldTextArea/FieldTextArea';
import FieldItemList from '../../../../components/FieldItemList/FieldItemList';
import PanelBase from '../../../../components/PanelBase/PanelBase';
import ButtonDefaultWithLoad from '../../../../components/ButtonDefaultWithLoad/ButtonDefaultWithLoad';
import FieldItemListAdd from '../../../../components/FieldItemListAdd/FieldItemListAdd';

const EmpEmplHistNewOT = (props) => {

    const { userInfo } = useContext(UserContext);

    const [initialData, setInitialData] = useState({
        "employmenttype": "OT",
        "historyid": -1,
        "begindate": null,
        "enddate": null,
        "basewagecurrcode": "MNT",
        "basewage": 0,
        "insuretypeid": null,
        "labourcondition": "N",
        "ismult": null,
        "multyear": 0,
        "note": null,
        "empid": props.empid,
        "companyid": userInfo.companyid ? userInfo.companyid.toString().toUpperCase() : "",
        "isgovcompany": false,
        "jobid": null,
        "govcategoryid": null,
        "jobcategoryid": null,
        "companyname": userInfo.companyname ? userInfo.companyname : "",
        "legalentityid": null,
        "olddepname": null,
        "jobname": null,
        "emptype": props.emptype
    });

    const [data, setData] = useState({ ...initialData });
    const [dLabourCondition, setDLabourCondition] = useState(constData.hrContract_LabourCondition);

    const [checkRule, setCheckRule] = useState(false);
    const [colSpan, setColSpan] = useState(window.innerWidth > 800 ? 12 : 24);
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const getExistsData = async () => {
        let tData = { ...initialData };
        if (props.historyid > 0) {

            setLoading(true);
            await API.get('/api/humanresource/employment/get_empemplhist?historyid=' + props.historyid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });

            setLoading(false);
        }
        setData(tData);
    }

    useEffect(() => {
        getExistsData();
    }, [props.historyid])

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setData(tData);
        }
    }

    const onSave = async () => {
        setCheckRule(true);

        let vRule = true;

        if (data.isgovcompany == null ||
            !data.begindate ||
            !data.enddate ||
            !data.labourcondition ||
            !data.insuretypeid) {
            vRule = false;
        }

        if (vRule) {
            setLoadingSave(true);
            let tData = { ...data };
            tData.empid = props.empid;
            tData.emptype = props.emptype;
            await API.post('/api/humanresource/employment/save_empemplhist', [tData]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    props.afterSave();
                    onDismiss();
                }
            });
            setLoadingSave(false);
        } 
    }

    const onDismiss = () => {
        setData({ ...initialData });
        setCheckRule(false);
        props.onDismiss();
    }

    const onDelete = async () => {
        await API.post('/api/humanresource/employment/delete_empemplhist?historyid=' + props.historyid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                props.afterSave();
                onDismiss();
            }
        });
    }

    return (
        <PanelBase
            headerText={props.historyid > 0 ? 'Өөр байгууллагад ажилласан түүх засах' : 'Өөр байгууллагад ажилласан түүх нэмэх'}
            isOpen={props.onOpen}
            onDismiss={onDismiss}
            PanelType='large'
            delete={!props.disable}
            onDelete={onDelete}
            buttons={(
                <div>
                    <ButtonDefaultWithLoad disable={props.disable} loading={loadingSave} onClick={onSave} text="Хадгалах" />
                </div>
            )}
        >
            <div style={{ marginTop: 25 }}>
                <div>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldItemListAdd loading={loading} onChanged={fieldOnChanged} title="Хуулийн этгээд" keyfield='legalentityid' keyfieldname='legalentityname' defaultValue={[{ key: data.legalentityid, name: data.legalentityname }]} dataurl="/api/humanresource/organization/get_legalentity_dropdown" saveurl="/api/humanresource/organization/save_Legalentity" />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldText loading={loading} onChanged={fieldOnChanged} title="Дотоод нэгж" keyfield='olddepname' defaultValue={data.olddepname} />
                        </Col>
                        <Col span={colSpan}>
                            <FieldText loading={loading} onChanged={fieldOnChanged} title="Албан тушаал" keyfield='jobname' defaultValue={data.jobname} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldDate loading={loading} required onChanged={fieldOnChanged} title="Эхэлсэн огноо" keyfield='begindate' defaultValue={data.begindate} checkreq={checkRule} />
                        </Col>
                        <Col span={colSpan}>
                            <FieldDate loading={loading} required onChanged={fieldOnChanged} title="Дууссан огноо" keyfield='enddate' defaultValue={data.enddate} checkreq={checkRule} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldItemList loading={loading} required onChanged={fieldOnChanged} title="Даатгуулагчийн төрөл" keyfield='insuretypeid' keyfieldname='insuretypename' defaultValue={[{ key: data.insuretypeid, name: data.insuretypename }]} checkreq={checkRule} dataurl="/api/humanresource/organization/get_insure_type_dropdown" />
                        </Col>
                        <Col span={colSpan}>
                            <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Хөдөлмөрийн нөхцөл" data={dLabourCondition} keyfield='labourcondition' defaultValue={data.labourcondition} checkreq={checkRule} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={24}>
                            <FieldTextArea loading={loading} onChanged={fieldOnChanged} title="Нэмэлт мэдээлэл" keyfield='note' defaultValue={data.note} />
                        </Col>
                    </Row>
                </div>
            </div>
        </PanelBase >
    );
}

export default EmpEmplHistNewOT;